import store from '@/store';

export const eventsSubscribe = (events: any, observable: any) => {
    store.commit('eventsSubscribe', { events, observable });
};

export const eventsUnsubscribe = (observable: any) => {
    store.commit('eventsUnsubscribe', { observable });
};

export const eventsDispatch = (event: string, payload: any = {}) => {
    store.commit('eventsDispatch', { event, payload });
};

export const events = {
    methods: {
        $_eventsSubscribe(events: any) {
            eventsSubscribe(events, this);
        },
        $_eventsUnsubscribe() {
            eventsUnsubscribe(this);
        },
        $_eventsDispatch: eventsDispatch,
    },
};
